// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"761":"css/admin-app.6837","7989":"css/app.6837"}[chunkId] + ".css";
};